import { observer } from "mobx-react";
import React, { useState } from "react";
import { GetAChannel } from "../../stores/GetAChannel";
import {
  Paper,
  Title,
  Textarea,
  CopyButton,
  Button,
  Text,
  Stack,
  Center,
  AspectRatio,
} from "@mantine/core";
import { IconCopy, IconQrcode } from "@tabler/icons-react";
import { QRCodeSVG } from "qrcode.react";

const ConnectToNode: React.FC<{ getAChannel: GetAChannel }> = observer(
  ({ getAChannel }) => {
    const [showQRCode, setShowQRCode] = useState(false);

    const nodeAddress =
      getAChannel.selectedNetwork === "Mainnet"
        ? "038a9e56512ec98da2b5789761f7af8f280baf98a09282360cd6ff1381b5e889bf@64.23.162.51:9735"
        : "03e30fda71887a916ef5548a4d02b06fe04aaa1a8de9e24134ce7f139cf79d7579@64.23.192.68:9736";

    return (
      <Paper withBorder p="md">
        <Stack>
          <Text>
            {" "}
            Please copy or scan our node's address. Your node should have a
            "connect to peer" button. Use that to connect to Megalith LSP.
          </Text>

          <CopyButton value={nodeAddress}>
            {({ copied, copy }) => (
              <Button leftSection={<IconCopy />} onClick={copy}>
                {copied ? "Copied!" : "Copy Our Address"}
              </Button>
            )}
          </CopyButton>
          <Button
            variant="outline"
            leftSection={<IconQrcode />}
            onClick={() => setShowQRCode(!showQRCode)}
          >
            {showQRCode ? "Hide QR Code" : "Our Address (QR Code)"}
          </Button>
          {showQRCode && (
            <Center>
              <AspectRatio ratio={1} style={{ maxWidth: 300 }}>
                <QRCodeSVG
                  value={nodeAddress}
                  title="Node Address QR Code"
                  size={300}
                  bgColor={"#ffffff"}
                  fgColor={"#000000"}
                  level={"L"}
                  marginSize={6}
                />
              </AspectRatio>
            </Center>
          )}
          <Text>
            Use the "connect to peer" (or similar) button on your Lightning
            Node....
          </Text>
          <Text>... OK! Are you sure you have connected to Megalith LSP?</Text>
          <Button
            onClick={() => getAChannel.setuserHasConfirmedIsConnected(true)}
          >
            Yes, I've Added Megalith LSP as a Peer
          </Button>
        </Stack>
      </Paper>
    );
  }
);

export default ConnectToNode;
